<template>
<!-- <v-list-tile href="javascript:;" @click="toggleSelected(id)"> -->
<div id="mySelect">
  <v-list-tile>
    <v-list-tile-action>
      <input type="checkbox" v-model="checkedItems" :value="id" @click="toggleCheckedItems(id)">
    </v-list-tile-action>
    </v-list-tile-action>
    <v-container fluid grid-list-md>
      <v-layout row wrap align-center>
        <avatar v-if="image !== null"
          username="Jane Doe"
          class="cursor-pointer"
          @click="selectPatient(person_id,shift)"
          :src="image.split('?')[0]"
          :size="30">
        </avatar>
        <div v-else class="cursor-pointer"
            @click="selectPatient(person_id,shift)">
          <i
            
            class="fas fa-user-circle fa-2x"
            style="color:lightgray"
            ></i>
        </div>
        <v-flex xs2 class="cursor-pointer" @click="selectPatient(person_id,shift)">
          <v-card class="pt pt-name" >
            {{name}}
          </v-card>
          </v-card>
        </v-flex>
        <v-flex xs1 class="pt_info">
          <span v-if='gender === "Male"'>M</span>
          <span v-if='gender === "Female"'>F</span>
          <span v-if='gender === "Other"'>Other</span>
          <span v-if='age !== null'>, {{age}}</span>
        </v-flex>
        </span>
        <v-flex xs3>
          <router-link v-if='print === "finished"'
          :to="{ name: 'prescription', params: { appId: `${id}`,ptId: `${person_id}`},  }"
          >
            <el-button type="default" @click="logInlocalStorage(billing,vitals,name,age,place,gender)">Prescription</el-button>
          </router-link>

        <router-link v-if='profile_status === "Incomplete"'
        :to="{ name: 'profileEdit', params: { appId: `${id}`,ptId: `${person_id}`},  }"
        >
        <el-button type="default" @click="logAppointmentInLS(dateTime)">
          Complete profile
        </el-button>
        </router-link>

        </v-flex>

        <v-flex xs2 style="padding:1.5rem"
          v-if='profile_status !== "Incomplete"'
          >
          <v-card
            class="pt pt-last-visit"
            v-if='lastVisit === "Newcomer"'
            >
            New Patient
          </v-card>

          <v-card
            class="pt pt-last-visit"
            v-else
            >
            {{lastVisit}}
          </v-card>
        </v-flex>


        <v-flex xs1 class="text-xs-right">
        </v-flex>
      </v-layout>
    </v-container>
  </v-list-tile>
</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Avatar from 'vue-avatar';
export default {
  name: 'PatientQueue',
  props: [
    'name',
    'gender',
    'age',
    'city',
    'lastVisit',
    'id',
    'order',
    'vitals',
    'person_id',
    'print',
    'profile_status',
    'dateTime',
    'image',
    'shift',
    'selectPatient'
  ],
  components: {
    avatar: Avatar
  },
  computed: {
    ...mapState(['appointment_id']),
    // checkedItems: state => state.checkedItems,
    checkedItems: {
      get(v) {
        return this.$store.state.checkedItems;
      },
      set(value) {
        console.log('value from patient comp');
        console.log(value);
        this.$store.commit('toggle', {
          value,
          id: this.id
        });
      }
    }
  },
  data() {
    return {
      btnToggle: true
      // notifications: false,
    };
  },
  mounted() {},
  methods: {
    logInlocalStorage(billing, vitals, name, age, place, gender) {
      localStorage.setItem('billingStatus', this.billing);
      localStorage.setItem('vitalsStatus', this.vitals);
      localStorage.setItem('ptName', this.name);
      localStorage.setItem('ptAge', this.age);
      localStorage.setItem('ptPlace', this.place);
      localStorage.setItem('ptGender', this.gender);
    },
    logAppointmentInLS(dateTime) {
      const apptTime = this.dateTime.split(' ');
      const aDate = apptTime[0];
      const aTime = apptTime[1];
      localStorage.setItem('aDate', aDate);
      localStorage.setItem('aTime', aTime);
    },
    test(id) {
      this.$store.state.appointment_id = this.id;
      this.$router.push('/prescription');
    },
    ...mapMutations(['toggleCheckedItems'])
  }
};
</script>
<style scoped>
.pt-head {
  /* flex-direction: row; */
  /* justify-content: space-between; */
}

.pt {
  font-family: 'Assistant', sans-serif;
  color: #4e4e4e;
  font-weight: 300;
  /* max-width: 100px; */
}

.pt-name::first-letter {
  text-transform: uppercase;
}
.pt-name:not(::first-letter) {
  text-transform: lowercase;
}

.pt-name {
  color: #484848;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.13px;
  line-height: 23px;
  padding-left: 0.2rem;
}

.pt-age,
.pt-gender,
.pt-city {
  opacity: 0.8;
  color: gray;
  font-size: 1.2rem;
}

.pt-last-visit {
  /* color:#000; */
}

.pt_info {
  color: #aeaeae;
  font-weight: 400;
}
input[type='checkbox'] {
  -webkit-appearance: none;
  border-radius: 2em;
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 1rem;
  border: 1px solid rgba(158, 158, 158, 0.52);
}
input[type='checkbox']:checked {
  background: #018fff
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E")
    no-repeat 50%;
  background-size: 70%;
}
.item {
  border-bottom: 0.5px solid #e0e0e0;
  /* padding: 0.5rem 0rem; */
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/PatientQueue.vue